






























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { Location } from "vue-router";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component
export default class InvestmentAccountLink extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop({required: true})
  routeToAccount: Location;

  @Prop({required: true})
  label: string;

  @Prop({required: false})
  balance: number;

  get accountBalance (): string {
    if (this.balance) {
      return formatCurrency(this.balance);
    }

    return "0.00";
  }

  get hsaInvestEnrollButtonDisabled (): boolean {
    return this.custodianSettingsStore.hsaInvestEnrollButtonDisabled;
  }
}
